import {
  AdminSettingsForm,
  AdminSettingsFormProps
} from 'components/shared/AdminSettings/AdminSettingsForm';
import { Skeleton } from '@mui/material';
import { FormFieldsWrapper } from 'components/shared/AdminSettings/FormFieldsWrapper';

export const MAX_WIDTH = 450;

interface Props {
  isFetching: boolean;
}

export const AdminSettingsFormWrapper = (
  props: AdminSettingsFormProps & Props
) => {
  const { isFetching = false, children } = props;

  if (isFetching) {
    return (
      <FormFieldsWrapper>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} width={MAX_WIDTH} height={40} />
        ))}
      </FormFieldsWrapper>
    );
  }

  return <AdminSettingsForm {...props}>{children}</AdminSettingsForm>;
};
